import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  button: {
    borderRadius: "20px",
    fontFamily: "Gilroy-Light, serif",
    textTransform: "capitalize",
    marginLeft: "1px",
    backgroundColor: "#f95919",
    maxHeight: "100%",
    color: "#fff",
    width: "150px",
    "&:hover": {
      backgroundColor: "#e45826",
      boxShadow: "none",
    },
  },

  // cardImage: {
  //   // width: "35%",
  //   [theme.breakpoints.down("xs")]: {
  //     textAlign: "center",
  //     justifyContent: "center",
  //     // width: "100%",
  //   },
  // },
  section: {
    width: "62%",
    paddingLeft: "15px",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      justifyContent: "center",
      width: "100%",
    },
  },

  sortButton: {
    borderRadius: "20px",
    fontFamily: "Gilroy-Light, serif",
    textTransform: "capitalize",
    marginLeft: "1px",
    borderColor: "#000",
    marginBottom: "7px",
    backgroundColor: "#fff",
    color: "#000",
    width: "150px",
    "&:hover": {
      borderColor: "#e45826",
      boxShadow: "none",
    },
  },

  dwnButton: {
    borderRadius: "20px",
    fontFamily: "Gilroy-Light, serif",
    textTransform: "capitalize",
    marginTop: "10px",
    backgroundColor: "#d62828",
    color: "#fff",
    maxWidth: "100%",
    width: "300px",
    "&:hover": {
      backgroundColor: "#d62830",
      boxShadow: "none",
    },
  },
  image: {},

  Trending: {
    marginTop: "55px",
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
    alignContent: "center",
  },
  menuWrap: {
    padding: "20px 20px 20px 20px",
    backgroundColor: "#FFFAF7",
    boxShadow: "0 3px 11px rgb(0 0 0 / 16%)",
    position: "relative",
    height: "281px",
    minWidth: "100%",
    [theme.breakpoints.down("md")]: {
      minWidth: "820px",
      height: "330px",
      paddingRight: "20px",
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: "540px",
      paddingRight: "20px",
      height: "231px",
    },
    [theme.breakpoints.down("xs")]: {
      minWidth: "300px",
      height: "329px",
    },
  },
  ColrRed: {
    color: "red",
  },
  ColorWhite: {
    color: "#fff",
  },
  colSpacing: {
    padding: "0px 7px",
  },
  price: {
    textAlign: "right",
    fontFamily: "Gilroy-Light, serif",
    fontSize: "16px",
    color: "#F95919",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      width: "100%",
      fontSize: 15,
      marginBottom: "15px",
    },
  },
  calories: {
    fontFamily: "Gilroy-ExtraBold, serif",
    fontSize: "12px",
    textAlign: "left",
    justifyContent: "flex-start",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      fontSize: 15,
    },
  },
  menuCard: {
    boxShadow: "0 3px 11px rgb(0 0 0 / 16%)",
    borderRadius: "4",
    padding: "0",
    marginBottom: "15px",
    position: "relative",
    width: "100%",
  },
  menuCardInner: {
    padding: "15px",
    "&:last-child": {
      paddingBottom: "15px ",
    },
  },
  chip: {
    margin: 3,
    // justifyContent: "center",
    flexWrap: "wrap",
    "&:first-child": {
      marginLeft: "0",
    },
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },

  expandchip: {
    margin: 3,
    textAlign: "left",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },

  cardImageWrap: {
    width: '34%',
    height: '100%',
    borderRadius: '4px',
    position: 'relative',
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      justifyContent: "center",
      display: 'flex',
      height: '150px',
      width: '100%',
      marginBottom: '15px;',
    },
  },
  cardImg: {
    minHeight: "168px",
    boxShadow: "0 3px 11px rgb(0 0 0 / 16%)",
    [theme.breakpoints.down("xs")]: {
      minHeight: "150px",
      width: "100%",
      borderRadius: "10px",
    },
  },
  menuCardHeader: {
    fontFamily: "Gilroy-ExtraBold, serif",
    fontSize: "17px",
    textAlign: "left",
    [theme.breakpoints.down("xs")]: {
      fontSize: "16px",
      textAlign: "center",
      marginBottom: "15px",
    },
  },
  cardDescription: {
    fontFamily: "Gilroy-Light, serif",
    fontSize: "14px",
    textAlign: "left",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      width: 260,
      marginBottom: "15px",
      height: "auto !important",
    },
  },
  tagExpand: {
    textAlign: "left",
    padding: "0px",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  divider: {
    borderColor: "1px solid #C8C7C6",
    margin: "15px 0px",
  },
  restaurantD: {
    borderRadius: "10px",
    boxShadow: "0 3px 11px rgb(0 0 0 / 16%)",
    marginLeft: "20px",
    [theme.breakpoints.down("md")]: {
      marginLeft: "10px",
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "10px",
    },
    [theme.breakpoints.down("xs")]: {
      margin: "10px",
    },
  },
  phoneBtn: {
    fontFamily: "Gilroy-ExtraBold, serif",
    fontSize: "20px",
    textTransform: "capitalize",
    fontWeight: "bold",
    marginRight: "10px",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },

  description: {
    fontFamily: "Gilroy-Light, serif",
    fontWeight: 300,
    textAlign: "left",
    fontSize: "14px",
    marginBottom: "5px",
  },
  map: {
    height: "200px",
    marginTop: "10px",
    width: "100%",
    marginBottom: "15px",
  },
  hrsTxt: {
    fontFamily: "Gilroy-ExtraBold, serif",
    fontWeight: 300,
    textAlign: "left",
    fontSize: "14px",
    marginTop: "10px",
  },
  logo: {
    height: "80px",
    marginBottom: "15px",
  },
  phone: {
    textAlign: "left",
    [theme.breakpoints.down("md")]: {
      textAlign: "right",
      display: "block",
    },
    [theme.breakpoints.down("sm")]: {
      textAlign: "right",
      display: "block",
    },
    [theme.breakpoints.down("xs")]: {
      textAlign: "left",
      justifyContent: "center",
      marginBottom: "0px",
      display: "block",
    },
  },
  linkButton: {
    fontFamily: "Gilroy-Light, serif",
    fontSize: "14px",
    textTransform: "capitalize",
    color: "#D62828",
    marginRight: "10px",
    float: "left",
    [theme.breakpoints.down("md")]: {
      float: "right",
    },
    [theme.breakpoints.down("sm")]: {
      float: "right",
    },
    [theme.breakpoints.down("xs")]: {
      float: "left",
    },
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
}));
